/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessDataNode {
        public nodeId: string;
        public variableType: Wars.Domain.Model.Codes.Enums.VariableType;
        public isReportable: boolean;
        public isGroupNode: boolean;
        public isVariableNode: boolean;

        constructor(nodeId: string, nodeType: string, variableType?: Wars.Domain.Model.Codes.Enums.VariableType, isReportable? : boolean) {
            this.nodeId = nodeId;
            this.isGroupNode = nodeType == 'group';
            this.isVariableNode = nodeType == "variable";
            this.variableType = variableType;
            this.isReportable = isReportable;
        }

        public static CreateGroup(nodeId: string) {
            return new ProcessDataNode(nodeId, 'group');
        }

        public static CreateVariable(nodeId: string, variableType: Wars.Domain.Model.Codes.Enums.VariableType, isReportable: boolean) {
            return new ProcessDataNode(nodeId, 'variable', variableType, isReportable);
        }
    }
}